import type { AgencyListTab } from '@saaga/shared/interfaces/agencies.interface'

import { agencyRoutes, orgRoutes } from '@/routes/org-routes.const'

export const getTabFromPath = (pathname: string): AgencyListTab => {
  if (pathname.includes(`/${orgRoutes.agencies}/${agencyRoutes.studio}`)) {
    return agencyRoutes.studio
  }
  if (pathname.includes(`/${orgRoutes.agencies}/${agencyRoutes.organization}`)) {
    return agencyRoutes.organization
  }
  if (pathname.includes(`/${orgRoutes.agencies}/${agencyRoutes.templates}`)) {
    return agencyRoutes.templates
  }
  return agencyRoutes.explore
}
